<template>
    <div class="road-point">
        <div class="preloader_horizontal">
            <div class="animate_element">
                <div class="animate_bus"></div>
                <div class="smoke">
                    <div class="smoke_item smoke_item1"></div>
                    <div class="smoke_item smoke_item2"></div>
                    <div class="smoke_item smoke_item3"></div>
                    <div class="smoke_item smoke_item4"></div>
                </div>
            </div>
        </div>
        <div class="road">
        </div>
    </div>
</template>

<script>
    export default {
        name: "AnimateCar"
    }
</script>

<style scoped>
    .animate_element {
        position: relative;
        width: 100%;
    }
    .preloader_horizontal {
        min-width: 100px;
        width: 100%;
        height: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
        overflow: hidden;
        -webkit-transform: translateZ(0) translate(-50%,0);
        transform: translateZ(0) translate(0,0);
        z-index: 2;
    }
    .animate_element {
        height: 120px;
        animation: horisontal_move 40s infinite linear;
        -webkit-animation: horisontal_move 40s infinite linear;
    }
    .animate_bus, .smoke, .smoke_item {
        position: absolute;
    }
    .animate_bus {
        width: 250px;
        height: 100px;
        bottom: -25px;
        left: 20px;
        background: url('../../../assets/images/bus-vxr.png') no-repeat;
        background-size: 80%;
    }
    .smoke {
        width: 60px;
        height: 20px;
        bottom: 30px;
        left: 0;
    }
    .smoke_item {
        width: 5px;
        height: 5px;
        right: 0;
        top: 10px;
        opacity: .3;
        transform: translate(0,0);
        -webkit-transform: translate(0,0);
        background-color: #000;
        border-radius: 50%;
    }
    .smoke_item1 {
        animation: smoke1 1.5s infinite ease-out;
        -webkit-animation: smoke1 1.5s infinite ease-out;
    }
    .smoke_item2 {
        animation: smoke2 1.5s infinite ease-out;
        -webkit-animation: smoke2 1.5s infinite ease-out;
        animation-delay: .4s;
        -webkit-animation-delay: .4s;
    }
    .smoke_item3 {
        animation: smoke1 1.5s infinite ease-out;
        -webkit-animation: smoke1 1.5s infinite ease-out;
        animation-delay: .8s;
        -webkit-animation-delay: .8s;
    }
    .smoke_item4 {
        animation: smoke2 1.5s infinite ease-out;
        -webkit-animation: smoke1 1.5s infinite ease-out;
        animation-delay: 1.2s;
        -webkit-animation-delay: 1.2s;
    }
    .road {
        width: 100%;
        height: 30px;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1;
        background-color: #4c4c4c;
        border-top: 1px #999 solid;
        border-bottom: 1px #999 solid;
    }
    .cloud2::after, .cloud2::before, .road::after {
        content: "";
    }
    .road::after {
        width: 100%;
        position: absolute;
        top: 50%;
        border-bottom: 2px dashed #777;
    }

    @keyframes horisontal_move {
        from {
            transform: translateX(0);
            -webkit-transform: translateX(0)
        }
        to {
            transform: translateX(100%);
            -webkit-transform: translateX(100%)
        }
    }

    @keyframes smoke1 {
        from {
            width: 5px;
            height: 5px;
            opacity: .3;
            right: 0;
            top: 5px
        }
        to {
            width: 20px;
            height: 20px;
            opacity: .1;
            right: 40px;
            top: 10px
        }
    }

    @keyframes smoke2 {
        from {
            width: 5px;
            height: 5px;
            opacity: .3;
            right: 0;
            top: 5px
        }
        to {
            width: 20px;
            height: 20px;
            opacity: .1;
            right: 40px;
            top: -5px
        }
    }
</style>
